import { render, staticRenderFns } from "./classifySet.vue?vue&type=template&id=59313f11&scoped=true&"
import script from "./classifySet.vue?vue&type=script&lang=js&"
export * from "./classifySet.vue?vue&type=script&lang=js&"
import style0 from "./classifySet.vue?vue&type=style&index=0&id=59313f11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59313f11",
  null
  
)

export default component.exports